module.exports = __webpack_public_path__ + "img/customer-icon2.f6c1ecaa.png";